import React from "react";
import { Link } from "react-router-dom";

import { BACKGROUNDS } from "../../data/content";

//Building blocks shared by the pages

//Photo fixed behind the page (decorative)
export const PageBackground = ({ src = BACKGROUNDS.PAGE }) => (
  <div
    className={"page-background"}
    style={{ backgroundImage: `url(${src})` }}
    aria-hidden={"true"}
  />
);

//Inner pages: page photo, red title tab (the page's h1), then the page's boxes
export const PageLayout = ({ title, background, className = "", children }) => (
  <div className={`page-layout ${className}`}>
    <PageBackground src={background} />
    <div className={"container"}>
      <h1 className={"page-title"}>{title}</h1>
      {children}
    </div>
  </div>
);

//Button that is either an internal page link, or an external link / file opened in a new tab
export const LinkButton = ({ path, href, className = "btn", children }) => (
  path ? (
    <Link
      to={path}
      className={className}
    >
      {children}
    </Link>
  ) : (
    <a
      href={href}
      className={className}
      target={"_blank"}
      rel={"noopener noreferrer"}
    >
      {children}
    </a>
  )
);
